"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyRenovationsBanner = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var PropertyRenovationsBanner = /** @class */ (function (_super) {
    __extends(PropertyRenovationsBanner, _super);
    function PropertyRenovationsBanner(props) {
        return _super.call(this, props) || this;
    }
    PropertyRenovationsBanner.prototype.render = function () {
        return (React.createElement("div", { className: "banner banner-info" },
            React.createElement("p", null,
                "Please",
                ' ',
                React.createElement("b", { className: "text-decoration-underline cursor-pointer text-blue-1", onClick: this.scrollToQuestion("propertyCondition") }, "tell us here"),
                ' ',
                "if your property undergoes structural renovations.")));
    };
    PropertyRenovationsBanner.prototype.scrollToQuestion = function (question) {
        return function () {
            var mobile = 200;
            var desktop = 160;
            var scrollOffset = window.innerWidth > 450 ? desktop : mobile;
            var panel = document.getElementById("propertyDetailsWidgetIdHidden");
            if (panel) {
                window.scrollTo(0, panel.getBoundingClientRect().top + window.scrollY - scrollOffset);
                panel.click();
            }
            var element = document.getElementById(question);
            if (element !== null) {
                scrollTo(0, element.getBoundingClientRect().top + window.scrollY - scrollOffset);
            }
        };
    };
    return PropertyRenovationsBanner;
}(plugin_journey_1.WidgetBase));
exports.PropertyRenovationsBanner = PropertyRenovationsBanner;
//# sourceMappingURL=PropertyRenovationsBanner.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/mta/PropertyRenovationsBanner.js
// module id = 3710
// module chunks = 0